<template>
    <svg
        width="1440"
        height="953"
        viewBox="0 0 1440 953"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="ILLUSTRATION">
            <rect
                id="floor"
                x="1"
                y="640"
                width="1439"
                height="299"
                fill="var(--lobbyFloor)"
                stroke="var(--lobbyStroke)"
            />
            <rect
                id="ceiling"
                y="34"
                width="1440"
                height="95"
                fill="var(--lobbyCeiling)"
                stroke="var(--lobbyStroke)"
            />
            <path
                id="Vector 8"
                d="M268 450L28 326L4 270H268V450Z"
                fill="var(--lobbyLeftSideCeilingRectangle)"
                stroke="var(--lobbyStroke)"
            />
            <path
                id="left wall"
                d="M243 662L0 710V83L50 124V314L243 397V662Z"
                fill="var(--lobbyLeftSideWall)"
                stroke="var(--lobbyStroke)"
            />
            <rect
                id="Rectangle 80"
                x="50"
                y="124"
                width="279"
                height="190"
                fill="var(--lobbyLeftSideCeilingRectangle)"
                stroke="var(--lobbyStroke)"
            />
            <path
                id="main wall"
                d="M578.858 69.1525H1363V706H238.01C238.01 520.286 222.393 126.354 252.798 95.8467C283.204 65.3391 481.008 69.1526 578.858 69.1525Z"
                fill="var(--lobbyBigWall)"
                stroke="var(--lobbyStroke)"
            />
            <g id="attendeebtn2" class="with-link hidden">
                <rect
                    x="650.5"
                    y="430.5"
                    width="192"
                    height="41"
                    rx="5.5"
                    fill="var(--lobbyButton)"
                    stroke="var(--lobbyButtonBorder)"
                />
                <text
                    fill="white"
                    xml:space="preserve"
                    style="white-space: pre"
                    font-family="Roboto Slab"
                    font-size="16"
                    font-weight="500"
                    letter-spacing="0px"
                >
                    <tspan x="668.219" y="455.8">
                        SEE WHO&#x2019;S HERE &#xbb;
                    </tspan>
                </text>
            </g>
            <g id="schedule" class="with-link hidden">
                <rect
                    x="850.5"
                    y="430.5"
                    width="169"
                    height="41"
                    rx="5.5"
                    fill="#F79E04"
                    stroke="white"
                />
                <text
                    fill="white"
                    xml:space="preserve"
                    style="white-space: pre"
                    font-family="Roboto Slab"
                    font-size="16"
                    font-weight="500"
                    letter-spacing="0px"
                >
                    <tspan x="868" y="455.5">
                        MY SCHEDULE &#xbb;
                    </tspan>
                </text>
            </g>
            <!-- TODO: After fact bootcamp Buttons Will be added as HTML element  -->
            <g id="VC-tip" class="with-link hidden">
                <rect
                    x="689.5"
                    y="442.5"
                    width="274"
                    height="41"
                    rx="5.5"
                    fill="var(--lobbyButton)"
                    stroke="var(--lobbyButtonBorder)"
                />
                <text
                    id="LOGOUT"
                    fill="white"
                    xml:space="preserve"
                    style="white-space: pre"
                    font-family="Public Sans"
                    font-size="16"
                    font-weight="bold"
                    letter-spacing="0px"
                >
                    <tspan x="708.346" y="468.8">
                        VIRTUAL CONFERENCE TIPS &#xbb;
                    </tspan>
                </text>
            </g>
            <g id="DESK">
                <g id="Union" opacity="0.0" filter="url(#filter0_f)">
                    <path
                        d="M473 517.992L612.311 514C622.97 517.75 716.369 520.682 830.012 520.682C940.764 520.682 1032.29 517.897 1046.74 514.285L1186 517.992V540.862H1184.96C1182.22 542.632 1174.1 544.329 1161.41 545.912V701.062C1087.72 724.613 967.73 740 830.012 740C692.294 740 570.544 724.613 496.848 701.062H498.611V546.039C485.335 544.419 476.857 542.679 474.039 540.862H473V517.992Z"
                        fill="#002751"
                    />
                </g>
                <path
                    id="Union_2"
                    d="M1153 530H506V711H504.28C576.218 735.799 695.066 752 829.5 752C963.934 752 1081.06 735.799 1153 711V530Z"
                    fill="var(--lobbyFrontDeskStand)"
                    stroke="var(--lobbyStroke)"
                />
                <path
                    id="Subtract"
                    d="M616.99 514.033L481 517V534H482.014C495.683 540.712 645.812 546 829 546C1012.19 546 1162.32 540.712 1175.99 534H1177V517L1041.06 514.244C1026.95 516.93 937.611 519 829.5 519C718.567 519 627.394 516.82 616.99 514.033Z"
                    fill="var(--lobbyFrontDeskTop)"
                    stroke="var(--lobbyStroke)"
                />
                <g id="messageCenter" class="with-link">
                    <title>Go to Message Center</title>
                    <g id="Group 100">
                        <path
                            d="M617.19 428.291L561.466 431.844C558.531 432.031 556.391 434.698 556.843 437.604L566.901 502.134C567.272 504.52 569.296 506.299 571.71 506.363L628.022 507.843C631.136 507.925 633.567 505.168 633.095 502.088L622.45 432.525C622.058 429.964 619.775 428.126 617.19 428.291Z"
                            fill="var(--lobbyDesktop)"
                            stroke="var(--lobbyStroke)"
                        />
                    </g>
                    <path
                        id="Vector 7"
                        d="M599 469H586.52C581.782 481.161 572.722 506.605 571.613 511.095C570.503 515.585 571.15 517.41 571.613 517.76C577.968 518.696 590.402 520.005 589.293 517.76C588.184 515.515 588.831 512.382 589.293 511.095L599 469Z"
                        fill="var(--lobbyDesktopStand)"
                        stroke="var(--lobbyStroke)"
                    />
                </g>
            </g>
            <g id="Group 102" opacity="0.1" filter="url(#filter1_f)">
                <path
                    id="Vector 9"
                    d="M595 667H426.694L397.127 739.044L164 892.611H375.52L577.942 739.044L595 667Z"
                    fill="var(--lobbyFeaturedContentShadow)"
                />
            </g>
            <g id="Group 98">
                <path
                    id="Vector"
                    d="M512.087 410.611C512.087 416.243 507.725 420.623 502.116 420.623H445.406C439.797 420.623 435.435 416.243 435.435 410.611V353.983C435.435 348.351 439.797 343.971 445.406 343.971H501.804C507.413 343.971 511.775 348.351 511.775 353.983V410.611H512.087Z"
                    fill="var(--loobyWallDecorBox)"
                    stroke="var(--lobbyStroke)"
                />
                <path
                    id="Vector_2"
                    d="M445.247 341C438.076 341 432.464 346.924 432.464 353.783V410.217C432.464 417.388 438.388 423 445.247 423H501.68C508.852 423 514.464 417.076 514.464 410.217V353.783C514.464 346.612 508.54 341 501.68 341H445.247ZM438.076 410.529V354.095C438.076 350.042 441.194 346.924 445.247 346.924H501.68C505.734 346.924 508.852 350.042 508.852 354.095V410.529C508.852 414.582 505.734 417.7 501.68 417.7H445.247C441.194 417.7 438.076 414.582 438.076 410.529Z"
                    fill="var(--lobbyWallDecorRectangle)"
                    stroke="var(--lobbyStroke)"
                />
                <path
                    id="Vector_3"
                    d="M494.855 359.42H316V390.319H494.855V359.42Z"
                    fill="var(--lobbyWallDecorInnerRectangle)"
                    stroke="var(--lobbyStroke)"
                />
            </g>
            <path
                id="Vector 1"
                d="M1441.42 14L1360 73.0831V706.434C1426.38 722.575 1428.15 721.884 1439.41 724.984C1450.68 728.083 1441.42 290.052 1441.42 14Z"
                fill="var(--lobbyRightSideWall)"
                stroke="var(--lobbyStroke)"
            />
            <g id="Group 104">
                <path
                    id="Vector_4"
                    d="M1445.01 337.502L1445.06 337.5H1445.11C1448.44 337.5 1451 334.943 1451 331.576V274.425C1451 271.15 1448.58 268.642 1445.38 268.506L1398.24 279.93L1397.95 280H1397.65C1394.32 280 1391.76 282.557 1391.76 285.924V333.576V335.386C1392.49 337.804 1394.66 339.48 1397.34 339.5L1445.01 337.502Z"
                    fill="var(--loobyWallDecorBox)"
                    stroke="var(--lobbyWallDecorBorderStroke)"
                    stroke-width="5"
                />
                <path
                    id="Vector_5"
                    d="M1404.5 289.5L1555 259.5V298.5L1404.5 312.5V289.5Z"
                    fill="var(--lobbyWallDecorInnerRectangle)"
                    stroke="var(--lobbyStroke)"
                />
            </g>
            <g id="Group 105">
                <path
                    id="Vector_6"
                    d="M1391.76 414.5V416.31C1392.5 418.743 1394.69 420.424 1397.39 420.424H1397.49L1397.6 420.433L1445.21 424.424C1448.49 424.375 1451 421.835 1451 418.5V366.424C1451 363.06 1448.44 360.505 1445.12 360.5L1397.67 360.924L1397.66 360.924H1397.65C1394.32 360.924 1391.76 363.481 1391.76 366.849V414.5Z"
                    fill="var(--loobyWallDecorBox)"
                    stroke="var(--lobbyWallDecorBorderStroke)"
                    stroke-width="5"
                />
                <path
                    id="Vector_7"
                    d="M1404 371H1555V404L1404 395.231V371Z"
                    fill="var(--lobbyWallDecorInnerRectangle)"
                    stroke="var(--lobbyStroke)"
                />
            </g>
            <g id="lamp_2" filter="url(#filter2_d)">
                <path
                    id="Vector_8"
                    d="M430.943 113.457V74.2469H440.656V107.948C451.341 108.597 461.378 110.217 470.768 112.485V117.022C453.284 115.402 440.332 114.43 430.943 113.457Z"
                    fill="var(--lobbyLampHead)"
                    stroke="var(--lobbyStroke)"
                />
                <path
                    id="Vector_9"
                    d="M414.106 108.273C415.402 108.273 416.697 107.948 418.316 107.948V74.2469H430.943V113.457C401.803 110.541 405.688 108.921 414.106 108.273Z"
                    fill="var(--lobbyLampHead)"
                    stroke="var(--lobbyStroke)"
                />
                <g id="Group">
                    <path
                        id="Vector_10"
                        d="M440.332 107.948C497.318 111.513 542 141.002 542 177.296C542 215.858 491.49 246.967 429 246.967C366.51 246.967 316 215.858 316 177.296C316 141.002 360.682 111.189 417.668 107.948"
                        fill="var(--lobbyLamp2)"
                        stroke="var(--lobbyStroke)"
                    />
                    <g id="Group_2">
                        <path
                            id="Vector_11"
                            d="M428 35H431V98H428V35Z"
                            fill="var(--lobbyLampHangers)"
                            stroke="var(--lobbyStroke)"
                        />
                    </g>
                    <g id="Group_3">
                        <path
                            id="Vector_12"
                            d="M501.851 177.296C501.851 146.187 479.834 119.614 448.103 108.596C501.527 114.105 542 142.946 542 177.296C542 211.97 501.203 240.486 447.779 245.995C479.51 234.977 501.851 208.405 501.851 177.296Z"
                            fill="var(--lobbyLampShadow)"
                        />
                    </g>
                    <g id="Group_4">
                        <path
                            id="Vector_13"
                            d="M515.126 177.296C515.126 216.506 476.596 248.264 429.324 248.264V245.995C475.301 245.995 512.86 215.21 512.86 177.296C512.86 141.65 480.482 112.485 437.419 108.921L437.743 106.652C481.777 110.217 515.126 140.678 515.126 177.296Z"
                            fill="var(--lobbyLampLines)"
                            stroke="var(--lobbyStroke)"
                        />
                        <path
                            id="Vector_14"
                            d="M486.957 177.296C486.957 216.506 461.054 248.264 429.324 248.264V245.995C459.759 245.995 484.69 215.21 484.69 177.296C484.69 141.65 463.321 112.485 434.828 108.92L435.152 106.652C464.616 110.217 486.957 140.678 486.957 177.296Z"
                            fill="var(--lobbyLampLines)"
                            stroke="var(--lobbyStroke)"
                        />
                        <path
                            id="Vector_15"
                            d="M458.788 177.296C458.788 217.154 445.836 248.264 429.323 248.264V245.995C444.217 245.995 456.521 215.21 456.521 177.296C456.521 142.298 445.836 112.161 431.914 108.92L432.561 106.652C447.455 110.541 458.788 140.678 458.788 177.296Z"
                            fill="var(--lobbyLampLines)"
                            stroke="var(--lobbyStroke)"
                        />
                        <path
                            id="Vector_16"
                            d="M430.295 107.948V226.876C430.295 248.263 430.295 248.264 429.324 248.264L428.352 247.291V107.948H430.295Z"
                            fill="var(--lobbyLampLines)"
                            stroke="var(--lobbyStroke)"
                        />
                        <path
                            id="Vector_17"
                            d="M426.734 108.92C412.811 112.161 402.126 142.298 402.126 177.296C402.126 215.21 414.43 245.995 429.324 245.995V248.264C412.811 248.264 399.86 217.154 399.86 177.296C399.86 140.678 411.192 110.541 426.086 106.652L426.734 108.92Z"
                            fill="var(--lobbyLampLines)"
                            stroke="var(--lobbyStroke)"
                        />
                        <path
                            id="Vector_18"
                            d="M423.82 108.92C395.327 112.485 373.957 141.65 373.957 177.296C373.957 215.21 398.889 245.995 429.324 245.995V248.264C397.594 248.264 371.691 216.506 371.691 177.296C371.691 140.678 394.032 110.217 423.496 106.652L423.82 108.92Z"
                            fill="var(--lobbyLampLines)"
                            stroke="var(--lobbyStroke)"
                        />
                        <path
                            id="Vector_19"
                            d="M421.23 108.92C378.167 112.485 345.788 141.65 345.788 177.296C345.788 215.21 383.347 245.995 429.324 245.995V248.264C382.052 248.264 343.522 216.506 343.522 177.296C343.522 140.678 376.871 110.217 420.906 106.652L421.23 108.92Z"
                            fill="var(--lobbyLampLines)"
                            stroke="var(--lobbyStroke)"
                        />
                    </g>
                </g>
            </g>
            <g id="lamp_1" filter="url(#filter3_d)">
                <path
                    id="Vector_20"
                    d="M77.7954 259.525V238.445H83.0175V256.564C88.7619 256.912 94.1581 257.783 99.2062 259.003V261.442C89.8063 260.571 82.8435 260.048 77.7954 259.525Z"
                    fill="var(--lobbyLampHead)"
                    stroke="var(--lobbyStroke)"
                />
                <path
                    id="Vector_21"
                    d="M68.7439 256.738C69.4402 256.738 70.1365 256.564 71.0069 256.564V238.445H77.7957V259.525C62.1292 257.957 64.2181 257.086 68.7439 256.738Z"
                    fill="var(--lobbyLampHead)"
                    stroke="var(--lobbyStroke)"
                />
                <g id="Group_5">
                    <path
                        id="Vector_22"
                        d="M82.8435 256.564C113.48 258.48 137.502 274.334 137.502 293.846C137.502 314.578 110.347 331.303 76.751 331.303C43.1552 331.303 16 314.578 16 293.846C16 274.334 40.0219 258.306 70.6585 256.564"
                        fill="var(--lobbyLamp1)"
                    />
                    <g id="Group_6">
                        <path
                            id="Vector_23"
                            d="M75.4493 0H77.7957V260.921H75.4493V0Z"
                            fill="var(--lobbyLampHangers)"
                            stroke="var(--lobbyStroke)"
                        />
                    </g>
                    <g id="Group_7">
                        <path
                            id="Vector_24"
                            d="M115.917 293.846C115.917 277.121 104.08 262.835 87.0212 256.912C115.743 259.874 137.502 275.379 137.502 293.846C137.502 312.487 115.569 327.819 86.8471 330.78C103.906 324.857 115.917 310.571 115.917 293.846Z"
                            fill="var(--lobbyLampShadow)"
                        />
                    </g>
                    <g id="Group_8">
                        <path
                            id="Vector_25"
                            d="M123.054 293.846C123.054 314.927 102.34 332 76.9252 332V330.781C101.643 330.781 121.836 314.23 121.836 293.846C121.836 274.682 104.429 259.003 81.277 257.087L81.4511 255.867C105.125 257.783 123.054 274.16 123.054 293.846Z"
                            fill="var(--lobbyLampLines)"
                            stroke="var(--lobbyStroke)"
                        />
                        <path
                            id="Vector_26"
                            d="M107.91 293.846C107.91 314.927 93.9841 332 76.9251 332V330.781C93.2878 330.781 106.691 314.23 106.691 293.846C106.691 274.683 95.2026 259.003 79.8843 257.087L80.0583 255.867C95.8989 257.783 107.91 274.16 107.91 293.846Z"
                            fill="var(--lobbyLampLines)"
                            stroke="var(--lobbyStroke)"
                        />
                        <path
                            id="Vector_27"
                            d="M92.7654 293.846C92.7654 315.275 85.8025 332 76.9249 332V330.781C84.9322 330.781 91.5469 314.23 91.5469 293.846C91.5469 275.031 85.8025 258.829 78.3174 257.087L78.6656 255.867C86.6729 257.958 92.7654 274.16 92.7654 293.846Z"
                            fill="var(--lobbyLampLines)"
                            stroke="var(--lobbyStroke)"
                        />
                        <path
                            id="Vector_28"
                            d="M77.4473 256.564V320.502C77.4473 332 77.4473 332 76.9251 332L76.4028 331.477V256.564H77.4473Z"
                            fill="var(--lobbyLampLines)"
                            stroke="var(--lobbyStroke)"
                        />
                        <path
                            id="Vector_29"
                            d="M75.5327 257.087C68.0476 258.829 62.3033 275.031 62.3033 293.846C62.3033 314.23 68.918 330.781 76.9253 330.781V332C68.0476 332 61.0848 315.275 61.0848 293.846C61.0848 274.16 67.1773 257.958 75.1846 255.867L75.5327 257.087Z"
                            fill="var(--lobbyLampLines)"
                            stroke="var(--lobbyStroke)"
                        />
                        <path
                            id="Vector_30"
                            d="M73.9661 257.087C58.6478 259.003 47.159 274.683 47.159 293.846C47.159 314.23 60.5626 330.781 76.9253 330.781V332C59.8663 332 45.9405 314.927 45.9405 293.846C45.9405 274.16 57.9515 257.783 73.792 255.867L73.9661 257.087Z"
                            fill="var(--lobbyLampLines)"
                            stroke="var(--lobbyStroke)"
                        />
                        <path
                            id="Vector_31"
                            d="M72.5735 257.087C49.422 259.003 32.0148 274.683 32.0148 293.846C32.0148 314.23 52.2071 330.781 76.9253 330.781V332C51.5108 332 30.7963 314.927 30.7963 293.846C30.7963 274.16 48.7257 257.783 72.3994 255.867L72.5735 257.087Z"
                            fill="var(--lobbyLampLines)"
                            stroke="var(--lobbyStroke)"
                        />
                    </g>
                </g>
            </g>
            <g id="seats">
                <g id="Setting" filter="url(#filter4_d)">
                    <g id="chair">
                        <path
                            id="Vector_32"
                            d="M1309.83 752.549C1309.83 739.839 1323.87 726.794 1310.83 726.794C1310.5 726.794 1311.17 726.794 1310.83 726.794C1310.5 726.794 1311.17 726.794 1310.83 726.794C1297.47 726.794 1311.84 739.504 1311.84 752.549C1311.84 765.259 1322.53 775.962 1335.9 775.962C1336.23 775.962 1336.57 775.962 1336.9 775.962V777.635H1284.77V775.962C1285.1 775.962 1285.44 775.962 1285.77 775.962C1299.14 775.628 1309.83 765.259 1309.83 752.549Z"
                            fill="var(--lobbyChairStand)"
                            stroke="var(--lobbyStroke)"
                        />
                        <path
                            id="Vector_33"
                            d="M1244 689.667C1252.35 684.316 1267.39 691.005 1274.74 695.353C1281.76 699.367 1288.11 699.702 1290.45 688.998C1292.79 677.961 1283.77 658.227 1277.42 648.192C1271.4 637.824 1266.05 624.11 1270.4 618.09C1275.08 611.735 1285.77 616.083 1310.5 621.1C1336.57 626.451 1350.94 620.096 1356.29 616.752C1360.63 614.076 1363.64 608.724 1365.64 608.39C1366.31 608.055 1366.65 608.39 1367.32 610.397C1369.32 616.417 1371.99 668.595 1364.64 702.377C1357.29 736.159 1333.23 756.228 1310.84 757.231C1279.76 758.904 1255.36 742.514 1244.67 720.105C1239.32 709.067 1237.65 693.681 1244 689.667Z"
                            fill="var(--lobbyChairTop)"
                            stroke="var(--lobbyStroke)"
                        />
                        <path
                            id="Vector_34"
                            opacity="0.5"
                            d="M1250.68 727.129C1260.37 735.49 1275.75 737.497 1289.45 727.463C1303.15 717.429 1311.51 700.705 1325.21 691.34C1338.58 681.974 1346.26 688.998 1348.6 691.674C1350.94 694.35 1360.3 706.391 1362.97 682.309C1365.31 660.902 1363.64 625.114 1363.64 619.762C1363.64 612.404 1365.64 604.042 1367.32 610.062C1368.99 616.083 1371.99 668.261 1364.64 702.043C1357.29 735.825 1333.23 755.893 1310.84 756.897C1279.09 758.569 1254.36 741.511 1244 718.432"
                            fill="var(--lobbyChairBottom)"
                            stroke="var(--lobbyStroke)"
                        />
                    </g>
                    <g id="chair_2">
                        <path
                            id="Vector_35"
                            d="M1041.16 752.549C1041.16 739.839 1027.12 726.794 1040.16 726.794C1040.49 726.794 1039.82 726.794 1040.16 726.794C1040.49 726.794 1039.82 726.794 1040.16 726.794C1053.53 726.794 1039.15 739.504 1039.15 752.549C1039.15 765.259 1028.46 775.962 1015.09 775.962C1014.76 775.962 1014.42 775.962 1014.09 775.962V777.635H1066.22V775.962C1065.89 775.962 1065.56 775.962 1065.22 775.962C1051.85 775.628 1041.16 765.259 1041.16 752.549Z"
                            fill="var(--lobbyChairStand)"
                            stroke="var(--lobbyStroke)"
                        />
                        <path
                            id="Vector_36"
                            d="M1106.99 689.667C1098.64 684.316 1083.6 691.005 1076.25 695.353C1069.23 699.367 1062.88 699.702 1060.54 688.998C1058.2 677.961 1067.22 658.227 1073.57 648.192C1079.59 637.824 1084.94 624.11 1080.59 618.09C1075.91 611.735 1065.22 616.083 1040.49 621.1C1014.42 626.451 1000.05 620.096 994.705 616.752C990.36 614.076 987.352 608.724 985.347 608.39C984.679 608.055 984.345 608.39 983.676 610.397C981.671 616.417 978.997 668.595 986.35 702.377C993.702 736.159 1017.76 756.228 1040.16 757.231C1071.24 758.904 1095.63 742.514 1106.33 720.105C1111.67 709.067 1113.34 693.681 1106.99 689.667Z"
                            fill="var(--lobbyChairTop)"
                            stroke="var(--lobbyStroke)"
                        />
                        <path
                            id="Vector_37"
                            opacity="0.5"
                            d="M1100.31 727.129C1090.62 735.49 1075.25 737.497 1061.54 727.463C1047.84 717.429 1039.49 700.705 1025.79 691.34C1012.42 681.974 1004.73 688.998 1002.39 691.674C1000.05 694.35 990.695 706.391 988.021 682.309C985.682 660.902 987.353 625.114 987.353 619.762C987.353 612.404 985.348 604.042 983.677 610.062C982.006 616.083 978.998 668.261 986.35 702.043C993.702 735.825 1017.76 755.893 1040.16 756.897C1071.9 758.569 1096.63 741.511 1106.99 718.432"
                            fill="var(--lobbyChairBottom)"
                            stroke="var(--lobbyStroke)"
                        />
                    </g>
                    <g id="Group_9">
                        <path
                            id="TableStand-2"
                            d="M1174.02 690.443V763.916C1177.11 771.287 1190.18 776.993 1205.62 776.993C1206.09 776.993 1206.57 776.993 1207.05 776.993V778.182H1136.96V776.993C1137.44 776.993 1137.91 776.993 1138.39 776.993C1153.83 776.993 1166.66 771.524 1169.98 763.916V690.443"
                            fill="var(--lobbyTable2Stand)"
                            stroke="var(--lobbyStroke)"
                        />
                        <g id="Group_10">
                            <path
                                id="Vector_39"
                                d="M1120.8 688.779H1223.2V692.821H1120.8V688.779Z"
                                fill="var(--lobbyTable1TopBase)"
                                stroke="var(--lobbyStroke)"
                            />
                            <path
                                id="Vector_40"
                                d="M1120.8 687.352H1223.2V688.778H1120.8V687.352Z"
                                fill="var(--lobbyTable1Top)"
                                stroke="var(--lobbyStroke)"
                            />
                        </g>
                    </g>
                </g>
                <g id="Setting_2" opacity="0.15">
                    <mask
                        id="mask0"
                        mask-type="alpha"
                        maskUnits="userSpaceOnUse"
                        x="978"
                        y="777"
                        width="402"
                        height="101"
                    >
                        <rect
                            id="Rectangle 74"
                            x="978.13"
                            y="777.813"
                            width="401.478"
                            height="100.187"
                            fill="url(#paint6_linear)"
                        />
                    </mask>
                    <g mask="url(#mask0)">
                        <g id="chair_3">
                            <path
                                id="Vector_41"
                                d="M1309.83 792.369C1309.83 799.918 1323.87 807.665 1310.83 807.665C1310.5 807.665 1311.17 807.665 1310.83 807.665C1310.5 807.665 1311.17 807.665 1310.83 807.665C1297.47 807.665 1311.84 800.116 1311.84 792.369C1311.84 784.82 1322.53 778.463 1335.9 778.463C1336.23 778.463 1336.57 778.463 1336.9 778.463V777.47H1284.77V778.463C1285.1 778.463 1285.44 778.463 1285.77 778.463C1299.14 778.662 1309.83 784.82 1309.83 792.369Z"
                                fill="var(--lobbyChairShadow)"
                            />
                            <path
                                id="Vector_42"
                                d="M1244 829.713C1252.35 832.892 1267.39 828.919 1274.74 826.336C1281.76 823.952 1288.11 823.754 1290.45 830.111C1292.79 836.666 1283.77 848.386 1277.42 854.346C1271.4 860.504 1266.05 868.649 1270.4 872.224C1275.08 875.999 1285.77 873.416 1310.5 870.437C1336.57 867.258 1350.94 871.033 1356.29 873.019C1360.63 874.608 1363.64 877.787 1365.64 877.985C1366.31 878.184 1366.65 877.985 1367.31 876.793C1369.32 873.218 1371.99 842.228 1364.64 822.164C1357.29 802.101 1333.23 790.182 1310.84 789.586C1279.76 788.592 1255.36 798.326 1244.66 811.636C1239.32 818.191 1237.65 827.329 1244 829.713Z"
                                fill="var(--lobbyChairShadow)"
                            />
                            <path
                                id="Vector_43"
                                opacity="0.5"
                                d="M1250.68 807.467C1260.37 802.5 1275.75 801.309 1289.45 807.268C1303.15 813.228 1311.5 823.16 1325.21 828.722C1338.57 834.285 1346.26 830.113 1348.6 828.524C1350.94 826.934 1360.3 819.783 1362.97 834.086C1365.31 846.799 1363.64 868.055 1363.64 871.234C1363.64 875.604 1365.64 880.57 1367.32 876.994C1368.99 873.419 1371.99 842.429 1364.64 822.365C1357.29 802.302 1333.23 790.383 1310.84 789.787C1279.09 788.794 1254.36 798.925 1244 812.632"
                                fill="var(--lobbyChairShadow)"
                            />
                        </g>
                        <g id="chair_4">
                            <path
                                id="Vector_44"
                                d="M1041.16 792.369C1041.16 799.918 1027.12 807.665 1040.16 807.665C1040.49 807.665 1039.82 807.665 1040.16 807.665C1040.49 807.665 1039.82 807.665 1040.16 807.665C1053.52 807.665 1039.15 800.116 1039.15 792.369C1039.15 784.82 1028.46 778.464 1015.09 778.464C1014.76 778.464 1014.42 778.464 1014.09 778.464V777.47H1066.22V778.464C1065.89 778.464 1065.56 778.464 1065.22 778.464C1051.85 778.662 1041.16 784.82 1041.16 792.369Z"
                                fill="var(--lobbyChairShadow)"
                            />
                            <path
                                id="Vector_45"
                                d="M1106.99 829.713C1098.64 832.891 1083.6 828.918 1076.25 826.336C1069.23 823.952 1062.88 823.753 1060.54 830.11C1058.2 836.666 1067.22 848.386 1073.57 854.346C1079.59 860.504 1084.94 868.648 1080.59 872.224C1075.91 875.999 1065.22 873.416 1040.49 870.436C1014.42 867.258 1000.05 871.032 994.704 873.019C990.36 874.608 987.352 877.786 985.347 877.985C984.678 878.184 984.344 877.985 983.676 876.793C981.671 873.217 978.997 842.228 986.349 822.164C993.701 802.1 1017.76 790.181 1040.15 789.585C1071.23 788.592 1095.63 798.326 1106.33 811.636C1111.67 818.191 1113.34 827.329 1106.99 829.713Z"
                                fill="var(--lobbyChairShadow)"
                            />
                            <path
                                id="Vector_46"
                                opacity="0.5"
                                d="M1100.31 807.467C1090.62 802.501 1075.24 801.309 1061.54 807.268C1047.84 813.228 1039.49 823.16 1025.78 828.722C1012.42 834.285 1004.73 830.113 1002.39 828.524C1000.05 826.935 990.693 819.783 988.02 834.086C985.681 846.8 987.351 868.055 987.351 871.234C987.351 875.604 985.346 880.57 983.675 876.995C982.004 873.419 978.997 842.429 986.349 822.366C993.701 802.302 1017.76 790.383 1040.15 789.787C1071.9 788.794 1096.63 798.925 1106.99 812.632"
                                fill="var(--lobbyChairShadow)"
                            />
                        </g>
                        <g id="Group_11">
                            <path
                                id="Vector_47"
                                d="M1174.02 829.255V785.619C1177.11 781.241 1190.18 777.852 1205.62 777.852C1206.1 777.852 1206.57 777.852 1207.05 777.852V777.145H1136.96V777.852C1137.44 777.852 1137.91 777.852 1138.39 777.852C1153.83 777.852 1166.66 781.1 1169.98 785.619V829.255"
                                fill="var(--lobbyTableShadow)"
                            />
                            <g id="Group_12">
                                <path
                                    id="Vector_48"
                                    d="M1120.8 830.243H1223.2V827.843H1120.8V830.243Z"
                                    fill="var(--lobbyTableShadow)"
                                />
                                <path
                                    id="Vector_49"
                                    d="M1120.8 831.091H1223.2V830.244H1120.8V831.091Z"
                                    fill="var(--lobbyTableShadow)"
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
            <g id="seats_2" filter="url(#filter5_d)">
                <g id="chair_5">
                    <path
                        id="Vector_50"
                        d="M879.441 795.621C879.441 778.596 898.242 761.123 880.784 761.123C880.337 761.123 881.232 761.123 880.784 761.123C880.337 761.123 881.232 761.123 880.784 761.123C862.878 761.123 882.127 778.148 882.127 795.621C882.127 812.646 896.452 826.982 914.358 826.982C914.805 826.982 915.253 826.982 915.701 826.982V829.223H845.868V826.982C846.315 826.982 846.763 826.982 847.211 826.982C865.116 826.534 879.441 812.646 879.441 795.621Z"
                        fill="var(--lobbyChairStand)"
                        stroke="var(--lobbyStroke)"
                    />
                    <path
                        id="Vector_51"
                        d="M791.256 711.392C802.447 704.223 822.591 713.184 832.44 719.008C841.84 724.384 850.345 724.832 853.479 710.495C856.612 695.711 844.526 669.277 836.021 655.836C827.963 641.948 820.801 623.579 826.62 615.514C832.887 607.002 847.212 612.826 880.338 619.546C915.254 626.715 934.503 618.202 941.666 613.722C947.485 610.138 951.514 602.97 954.2 602.522C955.095 602.074 955.543 602.522 956.438 605.21C959.124 613.274 962.705 683.166 952.857 728.416C943.009 773.667 910.778 800.548 880.786 801.893C839.154 804.133 806.476 782.179 792.151 752.162C784.989 737.377 782.75 716.768 791.256 711.392Z"
                        fill="var(--lobbyChairTop)"
                        stroke="var(--lobbyStroke)"
                    />
                    <path
                        id="Vector_52"
                        opacity="0.5"
                        d="M800.21 761.571C813.192 772.771 833.784 775.46 852.137 762.019C870.491 748.578 881.682 726.177 900.036 713.632C917.942 701.087 928.238 710.496 931.371 714.08C934.505 717.664 947.039 733.793 950.62 701.536C953.754 672.862 951.515 624.923 951.515 617.755C951.515 607.898 954.201 596.698 956.44 604.762C958.678 612.827 962.707 682.718 952.858 727.969C943.01 773.219 910.779 800.101 880.787 801.445C838.26 803.685 805.134 780.836 791.257 749.922"
                        fill="var(--lobbyChairBottom)"
                        stroke="var(--lobbyStroke)"
                    />
                </g>
                <g id="chair_6">
                    <path
                        id="Vector_53"
                        d="M519.558 795.621C519.558 778.596 500.757 761.123 518.215 761.123C518.663 761.123 517.768 761.123 518.215 761.123C518.663 761.123 517.768 761.123 518.215 761.123C536.121 761.123 516.872 778.148 516.872 795.621C516.872 812.646 502.547 826.982 484.642 826.982C484.194 826.982 483.746 826.982 483.299 826.982V829.223H553.132V826.982C552.684 826.982 552.236 826.982 551.789 826.982C533.883 826.534 519.558 812.646 519.558 795.621Z"
                        fill="var(--lobbyChairStand)"
                        stroke="var(--lobbyStroke)"
                    />
                    <path
                        id="Vector_54"
                        d="M607.743 711.392C596.552 704.223 576.408 713.184 566.56 719.008C557.159 724.384 548.654 724.832 545.52 710.495C542.387 695.711 554.473 669.277 562.979 655.836C571.036 641.948 578.199 623.579 572.379 615.514C566.112 607.002 551.787 612.826 518.661 619.546C483.745 626.715 464.496 618.202 457.333 613.722C451.514 610.138 447.485 602.97 444.799 602.522C443.904 602.074 443.456 602.522 442.561 605.21C439.875 613.274 436.294 683.166 446.142 728.416C455.99 773.667 488.221 800.548 518.214 801.893C559.845 804.133 592.523 782.179 606.848 752.162C614.011 737.377 616.249 716.768 607.743 711.392Z"
                        fill="var(--lobbyChairTop)"
                        stroke="var(--lobbyStroke)"
                    />
                    <path
                        id="Vector_55"
                        opacity="0.5"
                        d="M598.79 761.571C585.808 772.771 565.216 775.46 546.863 762.019C528.509 748.578 517.318 726.177 498.964 713.632C481.058 701.087 470.762 710.496 467.629 714.08C464.495 717.664 451.961 733.793 448.38 701.536C445.246 672.862 447.484 624.923 447.484 617.755C447.484 607.898 444.799 596.698 442.56 604.762C440.322 612.827 436.293 682.718 446.141 727.969C455.99 773.219 488.221 800.101 518.213 801.445C560.74 803.685 593.866 780.836 607.743 749.922"
                        fill="var(--lobbyChairBottom)"
                        stroke="var(--lobbyStroke)"
                    />
                </g>
                <g id="Group_13">
                    <path
                        id="Table2"
                        d="M697.525 712.431V810.846C701.662 820.72 719.165 828.363 739.85 828.363C740.486 828.363 741.123 828.363 741.759 828.363V829.956H647.881V828.363C648.518 828.363 649.154 828.363 649.791 828.363C670.476 828.363 687.66 821.038 692.115 810.846V712.431"
                        fill="var(--lobbyTable1Stand)"
                        stroke="var(--lobbyStroke)"
                    />
                    <g id="Group_14">
                        <path
                            id="Vector_57"
                            d="M626.241 710.202H763.397V715.616H626.241V710.202Z"
                            fill="var(--lobbyTable1TopBase)"
                            stroke="var(--lobbyStroke)"
                        />
                        <path
                            id="Vector_58"
                            d="M626.241 708.29H763.397V710.201H626.241V708.29Z"
                            fill="var(--lobbyTable1Top)"
                            stroke="var(--lobbyStroke)"
                        />
                    </g>
                </g>
            </g>
            <g id="Setting_3" opacity="0.15">
                <mask
                    id="mask1"
                    mask-type="alpha"
                    maskUnits="userSpaceOnUse"
                    x="417"
                    y="832"
                    width="578"
                    height="103"
                >
                    <rect
                        id="Rectangle 73"
                        x="417"
                        y="832"
                        width="578"
                        height="103"
                        fill="url(#paint7_linear)"
                    />
                </mask>
                <g mask="url(#mask1)">
                    <g id="chair_7">
                        <path
                            id="Vector_59"
                            d="M878.721 846.586C878.721 853.583 897.428 860.764 880.057 860.764C879.612 860.764 880.503 860.764 880.057 860.764C879.612 860.764 880.503 860.764 880.057 860.764C862.241 860.764 881.393 853.767 881.393 846.586C881.393 839.588 895.646 833.696 913.463 833.696C913.908 833.696 914.354 833.696 914.799 833.696V832.775H845.315V833.696C845.761 833.696 846.206 833.696 846.651 833.696C864.468 833.88 878.721 839.588 878.721 846.586Z"
                            fill="var(--lobbyChairShadow)"
                        />
                        <path
                            id="Vector_60"
                            d="M790.976 881.203C802.112 884.149 822.155 880.467 831.954 878.073C841.308 875.863 849.77 875.679 852.888 881.571C856.006 887.648 843.98 898.512 835.517 904.036C827.5 909.744 820.373 917.294 826.164 920.608C832.399 924.107 846.653 921.713 879.613 918.951C914.355 916.005 933.508 919.504 940.634 921.345C946.424 922.818 950.433 925.764 953.105 925.948C953.996 926.133 954.442 925.948 955.333 924.844C958.005 921.529 961.568 892.804 951.769 874.206C941.97 855.608 909.901 844.56 880.058 844.007C838.635 843.087 806.12 852.109 791.867 864.447C784.741 870.523 782.514 878.993 790.976 881.203Z"
                            fill="var(--lobbyChairShadow)"
                        />
                        <path
                            id="Vector_61"
                            opacity="0.5"
                            d="M799.886 860.58C812.803 855.977 833.292 854.872 851.553 860.396C869.815 865.92 880.951 875.127 899.212 880.283C917.029 885.439 927.273 881.572 930.391 880.099C933.509 878.625 945.98 871.997 949.544 885.254C952.662 897.039 950.435 916.742 950.435 919.688C950.435 923.739 953.107 928.343 955.334 925.028C957.561 921.714 961.57 892.988 951.771 874.39C941.972 855.793 909.902 844.744 880.06 844.192C837.746 843.271 804.785 852.662 790.978 865.368"
                            fill="var(--lobbyChairShadow)"
                        />
                    </g>
                    <g id="chair_8">
                        <path
                            id="Vector_62"
                            d="M520.638 846.586C520.638 853.583 501.931 860.764 519.302 860.764C519.747 860.764 518.856 860.764 519.302 860.764C519.747 860.764 518.856 860.764 519.302 860.764C537.118 860.764 517.966 853.767 517.966 846.586C517.966 839.588 503.713 833.696 485.896 833.696C485.451 833.696 485.005 833.696 484.56 833.696V832.775H554.044V833.696C553.598 833.696 553.153 833.696 552.708 833.696C534.891 833.88 520.638 839.588 520.638 846.586Z"
                            fill="var(--lobbyChairShadow)"
                        />
                        <path
                            id="Vector_63"
                            d="M608.382 881.203C597.247 884.149 577.203 880.467 567.404 878.073C558.051 875.863 549.588 875.679 546.47 881.571C543.352 887.648 555.378 898.512 563.841 904.036C571.858 909.744 578.985 917.294 573.195 920.608C566.959 924.107 552.706 921.713 519.746 918.951C485.004 916.005 465.851 919.504 458.724 921.345C452.934 922.818 448.925 925.764 446.253 925.948C445.362 926.133 444.917 925.948 444.026 924.844C441.353 921.529 437.79 892.804 447.589 874.206C457.388 855.608 489.458 844.56 519.3 844.007C560.723 843.087 593.238 852.109 607.491 864.447C614.618 870.523 616.845 878.993 608.382 881.203Z"
                            fill="var(--lobbyChairShadow)"
                        />
                        <path
                            id="Vector_64"
                            opacity="0.5"
                            d="M599.473 860.58C586.556 855.977 566.067 854.872 547.805 860.396C529.543 865.92 518.408 875.127 500.146 880.283C482.33 885.439 472.085 881.572 468.968 880.099C465.85 878.625 453.378 871.997 449.815 885.254C446.697 897.039 448.924 916.742 448.924 919.688C448.924 923.739 446.252 928.343 444.025 925.028C441.798 921.714 437.789 892.988 447.588 874.39C457.387 855.793 489.456 844.744 519.299 844.192C561.613 843.271 594.573 852.662 608.381 865.368"
                            fill="var(--lobbyChairShadow)"
                        />
                    </g>
                    <g id="Group_15">
                        <path
                            id="Vector_65"
                            d="M697.715 880.776V840.328C701.831 836.27 719.246 833.128 739.828 833.128C740.461 833.128 741.094 833.128 741.728 833.128V832.474H648.32V833.128C648.953 833.128 649.586 833.128 650.219 833.128C670.801 833.128 687.899 836.139 692.332 840.328V880.776"
                            fill="var(--lobbyTableShadow)"
                        />
                        <g id="Group_16">
                            <path
                                id="Vector_66"
                                d="M626.786 881.693H763.257V879.467H626.786V881.693Z"
                                fill="var(--lobbyTableShadow)"
                            />
                            <path
                                id="Vector_67"
                                d="M626.786 882.478H763.257V881.693H626.786V882.478Z"
                                fill="var(--lobbyTableShadow)"
                            />
                        </g>
                    </g>
                </g>
            </g>
            <!-- TODO: After fact bootcamp Buttons Will be added as HTML element  -->
            <g id="attendeebtn1" class="with-link hidden">
                <rect
                    x="602.5"
                    y="627.5"
                    width="192"
                    height="41"
                    rx="5.5"
                    fill="var(--lobbyButton)"
                    stroke="var(--lobbyButtonBorder)"
                />
                <text
                    fill="white"
                    xml:space="preserve"
                    style="white-space: pre"
                    font-family="Public Sans"
                    font-size="16"
                    font-weight="bold"
                    letter-spacing="0px"
                >
                    <tspan x="624.219" y="653.8">
                        SEE WHO&#x2019;S HERE &#xbb;
                    </tspan>
                </text>
            </g>
            <g id="door">
                <path
                    id="Vector 3"
                    d="M52 699V432.356V430L97 441.306V691.933L52 699Z"
                    fill="var(--lobbyDoor)"
                    stroke="var(--lobbyStroke)"
                />
                <path
                    id="Vector_68"
                    d="M83 484C83 500.5 85.0454 514 87.5 514C89.9545 514 92 500.5 92 484C92 467.5 89.9545 454 87.5 454C85.0454 454.3 83 467.5 83 484Z"
                    fill="var(--lobbyDoorKnob)"
                    stroke="var(--lobbyStroke)"
                />
            </g>
            <g id="FEATURED">
                <path
                    id="Vector_68"
                    d="M278.462 746.842C278.462 714.842 258 682 277 682C277.487 682 276.513 682 277 682C277.487 682 276.513 682 277 682C296.487 682 275.538 714 275.538 746.842C275.538 778.842 259.949 805.789 240.462 805.789C239.974 805.789 239.487 805.789 239 805.789V810H315V805.789C314.513 805.789 314.026 805.789 313.539 805.789C294.051 804.947 278.462 778.842 278.462 746.842Z"
                    fill="var(--lobbyFeaturedContentStand)"
                    stroke="var(--lobbyStroke)"
                />
                <g id="banner">
                    <g id="Group 4">
                        <mask
                            id="mask3"
                            mask-type="alpha"
                            maskUnits="userSpaceOnUse"
                            x="141"
                            y="94"
                            width="258"
                            height="637"
                        >
                            <rect
                                id="Rectangle 2"
                                x="141.839"
                                y="94.2277"
                                width="256.501"
                                height="636.717"
                                fill="#CEE4E4"
                            />
                        </mask>
                        <g mask="url(#mask3)">
                            <rect
                                id="Rectangle 6"
                                x="141.839"
                                y="94.2277"
                                width="256.501"
                                height="698.543"
                                fill="var(--lobbyFeaturedContent)"
                            />
                        </g>
                    </g>
                    <g id="Rectangle 3">
                        <rect
                            x="140"
                            y="85"
                            width="260.179"
                            height="9.22778"
                            rx="2"
                            fill="var(--lobbyFeaturedContentFrame)"
                            stroke="var(--lobbyStroke)"
                        />
                    </g>
                    <g id="Rectangle 4">
                        <rect
                            x="140"
                            y="730.944"
                            width="260.179"
                            height="9.22778"
                            rx="2"
                            fill="var(--lobbyFeaturedContentFrame)"
                            stroke="var(--lobbyStroke)"
                        />
                    </g>
                </g>
            </g>
            <!-- <g id="FEATURED" filter="url(#filter6_d)">
                <g id="banner">
                    <g id="Group 4">
                        <g id="Rectangle 5" filter="url(#filter7_d)">
                            <rect
                                x="273.161"
                                y="681.772"
                                width="257"
                                height="6.99999"
                                rx="2"
                                transform="rotate(90 273.161 681.772)"
                                fill="var(--lobbyFeaturedContentStand)"
                                stroke="var(--lobbyStroke)"
                            />
                        </g>
                        <mask
                            id="mask2"
                            mask-type="alpha"
                            maskUnits="userSpaceOnUse"
                            x="140"
                            y="183"
                            width="257"
                            height="637"
                        >
                            <rect
                                id="Rectangle 2"
                                x="140"
                                y="183"
                                width="256.501"
                                height="636.717"
                                fill="#CEE4E4"
                            />
                        </mask>
                        <g mask="url(#mask2)">
                            <rect
                                id="Rectangle 6"
                                x="140.161"
                                y="185.772"
                                width="256.501"
                                height="625"
                                fill="var(--lobbyFeaturedContent)"
                            />
                        </g>
                    </g>
                    <g id="Rectangle 3" filter="url(#filter8_d)">
                        <rect
                            x="139"
                            y="177"
                            width="258"
                            height="9.22778"
                            rx="2"
                            fill="var(--lobbyFeaturedContentFrame)"
                            stroke="var(--lobbyStroke)"
                        />
                    </g>
                    <g id="Rectangle 4" filter="url(#filter9_d)">
                        <rect
                            x="138"
                            y="811"
                            width="260.179"
                            height="9.22778"
                            rx="2"
                            fill="var(--lobbyFeaturedContentFrame)"
                            stroke="var(--lobbyStroke)"
                        />
                    </g>
                </g>
            </g> -->
            <g id="lamp_3" filter="url(#filter10_d)">
                <path
                    id="Vector_69"
                    d="M1354.95 77.5672V46.0279H1362.76V73.1361C1371.35 73.6574 1379.43 74.9607 1386.98 76.7853V80.4344C1372.92 79.1312 1362.5 78.3492 1354.95 77.5672Z"
                    fill="var(--lobbyLampHead)"
                    stroke="var(--lobbyStroke)"
                />
                <path
                    id="Vector_70"
                    d="M1341.4 73.3967C1342.45 73.3967 1343.49 73.1361 1344.79 73.1361V46.0279H1354.95V77.5672C1331.51 75.2213 1334.63 73.918 1341.4 73.3967Z"
                    fill="var(--lobbyLampHead)"
                    stroke="var(--lobbyStroke)"
                />
                <g id="Group_17">
                    <path
                        id="Vector_71"
                        d="M1362.5 73.136C1408.34 76.0032 1444.28 99.7229 1444.28 128.916C1444.28 159.934 1403.65 184.957 1353.38 184.957C1303.12 184.957 1262.49 159.934 1262.49 128.916C1262.49 99.7229 1298.43 75.7426 1344.27 73.136"
                        fill="var(--lobbyLamp3)"
                    />
                    <g id="Group_18">
                        <path
                            id="Vector_72"
                            d="M1355 35H1354.95V79.6556H1355V35Z"
                            fill="#F58220"
                        />
                    </g>
                    <g id="Group_19">
                        <path
                            id="Vector_73"
                            d="M1411.98 128.916C1411.98 103.893 1394.27 82.5195 1368.75 73.6573C1411.72 78.0884 1444.28 101.287 1444.28 128.916C1444.28 156.806 1411.46 179.744 1368.49 184.175C1394.01 175.313 1411.98 153.939 1411.98 128.916Z"
                            fill="var(--lobbyLampShadow)"
                        />
                    </g>
                    <g id="Group_20">
                        <path
                            id="Vector_74"
                            d="M1422.66 128.916C1422.66 160.456 1391.67 186 1353.64 186V184.175C1390.63 184.175 1420.84 159.413 1420.84 128.916C1420.84 100.244 1394.79 76.7853 1360.15 73.9181L1360.42 72.0935C1395.83 74.9607 1422.66 99.4623 1422.66 128.916Z"
                            fill="var(--lobbyLampLines)"
                            stroke="var(--lobbyStroke)"
                        />
                        <path
                            id="Vector_75"
                            d="M1400 128.916C1400 160.456 1379.17 186 1353.64 186V184.175C1378.12 184.175 1398.18 159.413 1398.18 128.916C1398.18 100.244 1380.99 76.7853 1358.07 73.918L1358.33 72.0934C1382.03 74.9607 1400 99.4623 1400 128.916Z"
                            fill="var(--lobbyLampLines)"
                            stroke="var(--lobbyStroke)"
                        />
                        <path
                            id="Vector_76"
                            d="M1377.34 128.916C1377.34 160.977 1366.93 186 1353.64 186V184.175C1365.62 184.175 1375.52 159.413 1375.52 128.916C1375.52 100.766 1366.93 76.5246 1355.73 73.918L1356.25 72.0934C1368.23 75.2213 1377.34 99.4623 1377.34 128.916Z"
                            fill="var(--lobbyLampLines)"
                            stroke="var(--lobbyStroke)"
                        />
                        <path
                            id="Vector_77"
                            d="M1354.43 73.1359V168.797C1354.43 186 1354.43 186 1353.64 186L1352.86 185.218V73.1359H1354.43Z"
                            fill="var(--lobbyLampLines)"
                            stroke="var(--lobbyStroke)"
                        />
                        <path
                            id="Vector_78"
                            d="M1351.56 73.918C1340.36 76.5246 1331.77 100.766 1331.77 128.916C1331.77 159.413 1341.66 184.175 1353.64 184.175V186C1340.36 186 1329.94 160.977 1329.94 128.916C1329.94 99.4623 1339.06 75.2213 1351.04 72.0934L1351.56 73.918Z"
                            fill="var(--lobbyLampLines)"
                            stroke="var(--lobbyStroke)"
                        />
                        <path
                            id="Vector_79"
                            d="M1349.22 73.918C1326.3 76.7853 1309.11 100.244 1309.11 128.916C1309.11 159.413 1329.16 184.175 1353.64 184.175V186C1328.12 186 1307.29 160.456 1307.29 128.916C1307.29 99.4623 1325.26 74.9607 1348.96 72.0934L1349.22 73.918Z"
                            fill="var(--lobbyLampLines)"
                            stroke="var(--lobbyStroke)"
                        />
                        <path
                            id="Vector_80"
                            d="M1347.13 73.918C1312.49 76.7853 1286.45 100.244 1286.45 128.916C1286.45 159.413 1316.66 184.175 1353.64 184.175V186C1315.62 186 1284.63 160.456 1284.63 128.916C1284.63 99.4623 1311.45 74.9607 1346.87 72.0934L1347.13 73.918Z"
                            fill="var(--lobbyLampLines)"
                            stroke="var(--lobbyStroke)"
                        />
                    </g>
                </g>
            </g>
            <!-- <g id="Layer 2">
                <g id="Layer 1">
                    <g id="Group_21">
                        <g id="Group_22">
                            <path
                                id="Vector_81"
                                d="M69.9316 389.532C69.7934 389.463 69.6457 389.415 69.4934 389.39C69.3541 389.382 69.215 389.408 69.0881 389.466C68.9517 389.539 68.8322 389.639 68.7375 389.761C68.6107 389.915 68.504 390.084 68.4198 390.264C68.3176 390.509 68.2334 390.761 68.1678 391.019C68.0897 391.38 68.0312 391.745 67.9926 392.112C67.9926 392.505 67.894 392.943 67.872 393.435C67.8501 393.927 67.872 394.451 67.872 395.031C67.872 395.61 67.872 396.124 67.872 396.638C67.872 397.152 67.872 397.611 67.9706 398.048C68.0064 398.43 68.0613 398.809 68.135 399.185C68.1921 399.519 68.2726 399.847 68.376 400.169C68.4746 400.454 68.5732 400.716 68.6827 400.956C68.7859 401.172 68.903 401.38 69.0333 401.58C69.1514 401.744 69.2873 401.894 69.4387 402.028C69.568 402.146 69.7161 402.242 69.8769 402.312C70.0179 402.376 70.171 402.41 70.326 402.41C70.4634 402.409 70.5985 402.375 70.7204 402.312C70.8491 402.229 70.9637 402.125 71.06 402.006C71.1784 401.847 71.2777 401.674 71.3558 401.492C71.4524 401.25 71.5329 401.001 71.5969 400.749C71.6626 400.454 71.7174 400.115 71.7721 399.743C71.8269 399.371 71.8488 398.945 71.8707 398.475C71.8926 398.005 71.8707 397.502 71.8707 396.944C71.8707 396.387 71.8707 395.851 71.8707 395.348C71.8707 394.845 71.8707 394.397 71.7721 393.96C71.6735 393.522 71.6735 393.14 71.6078 392.779C71.5634 392.451 71.5012 392.127 71.4216 391.806C71.3339 391.511 71.2353 391.237 71.1367 390.997C71.0392 390.77 70.9257 390.551 70.7971 390.341C70.6864 390.168 70.5579 390.006 70.4137 389.86C70.2806 389.734 70.1336 389.624 69.9755 389.532H69.9316ZM101.582 416.863L102.042 413.463L101.417 409.418L101.932 409.681L102.798 413.813L102.096 417.093L101.582 416.874V416.863ZM102.841 417.41L103.291 414.043L102.677 410.063L103.181 410.315L104.025 414.393L103.345 417.618L102.841 417.41ZM58.8011 400.661L59.0859 380.818L61.0798 381.912L60.8716 398.103L65.0018 399.896V403.176L58.8011 400.661ZM78.0714 405.821C78.1675 405.867 78.2718 405.893 78.3782 405.898C78.4682 405.92 78.5621 405.92 78.6521 405.898C78.7412 405.857 78.8228 405.802 78.8931 405.734C78.9799 405.647 79.0536 405.547 79.1122 405.439C79.1875 405.304 79.2464 405.161 79.2875 405.012C79.3464 404.819 79.3903 404.622 79.4189 404.422C79.4542 404.179 79.4761 403.935 79.4847 403.69C79.4847 403.416 79.4847 403.121 79.4847 402.793V392.145L80.9417 392.954V403.34C80.9417 403.679 80.9417 404.007 80.9417 404.324C80.9417 404.641 80.9417 404.936 80.9417 405.231C80.9417 405.526 80.9417 405.789 80.8541 406.051C80.7664 406.313 80.7774 406.554 80.7336 406.794C80.6898 407.035 80.635 407.232 80.5802 407.429C80.5211 407.614 80.4516 407.797 80.372 407.975C80.297 408.126 80.2128 408.272 80.1201 408.412C80.0298 408.532 79.9309 408.646 79.8243 408.751C79.6086 408.927 79.3453 409.033 79.0684 409.057H78.6082C78.4317 409.02 78.2592 408.965 78.0933 408.894C77.9117 408.819 77.736 408.732 77.5675 408.631C77.4033 408.521 77.246 408.4 77.0964 408.27C76.944 408.138 76.8046 407.992 76.6801 407.833C76.5436 407.667 76.4192 407.492 76.3076 407.308C76.1981 407.111 76.0885 406.915 75.9899 406.696C75.8913 406.477 75.8037 406.128 75.6941 405.876C75.5846 405.625 75.5408 405.373 75.475 405.111C75.4093 404.848 75.3436 404.564 75.2997 404.28C75.2559 403.996 75.2011 403.69 75.1573 403.383C75.1135 403.077 75.0916 402.76 75.0697 402.432C75.0478 402.104 75.0697 401.765 75.0039 401.416C74.9382 401.066 75.0039 400.705 75.0039 400.322V389.576L76.5925 390.45V401.383C76.5925 401.711 76.5925 402.028 76.5925 402.312C76.5925 402.596 76.5925 402.881 76.6692 403.132C76.6995 403.375 76.7434 403.616 76.8006 403.854C76.8006 404.072 76.9102 404.269 76.9759 404.455C77.0438 404.623 77.1206 404.787 77.206 404.947C77.2784 405.082 77.3628 405.21 77.4579 405.329C77.5407 405.435 77.6323 405.534 77.7318 405.625C77.8286 405.701 77.9355 405.763 78.0495 405.811L78.0714 405.821ZM86.8138 406.685L86.7152 396.091L87.986 396.802L88.1394 412.687L86.9671 412.217L83.6806 399.513L83.7572 410.916L82.3769 410.348V393.632L83.7353 394.386L86.759 406.641L86.8138 406.685ZM98.9961 402.848V405.264L96.5202 403.941L96.6188 407.494L98.8098 408.587V410.993L96.6188 409.899L96.6845 413.573L99.259 414.666V417.159L95.6328 415.737L95.3918 400.858L98.9961 402.848ZM69.855 405.395C69.6489 405.307 69.4509 405.201 69.2634 405.078C69.0683 404.949 68.885 404.802 68.7156 404.641C68.5271 404.463 68.3548 404.269 68.2007 404.061C68.0262 403.838 67.8653 403.604 67.7187 403.362C67.5653 403.099 67.4229 402.815 67.2914 402.531C67.16 402.246 67.0285 401.918 66.9189 401.59C66.8094 401.263 66.6889 400.913 66.5903 400.497C66.4917 400.082 66.404 399.754 66.3164 399.404C66.2288 399.054 66.163 398.584 66.1082 398.158C66.0535 397.731 65.9987 397.294 65.9549 396.846C65.911 396.397 65.8891 395.916 65.8782 395.446C65.8672 394.976 65.8782 394.473 65.8782 393.97C65.8782 393.468 65.8782 392.987 65.8782 392.527C65.8782 392.068 65.8782 391.642 65.9877 391.237C66.0973 390.833 66.0863 390.439 66.1521 390.078C66.2178 389.718 66.2945 389.379 66.3821 389.062C66.4625 388.764 66.5613 388.472 66.6779 388.187C66.7698 387.939 66.8797 387.698 67.0066 387.466C67.1174 387.269 67.2497 387.086 67.401 386.919C67.5238 386.765 67.6676 386.629 67.8282 386.514C67.9734 386.413 68.1319 386.332 68.2993 386.274C68.4645 386.216 68.6392 386.19 68.8142 386.197C68.9969 386.195 69.1785 386.225 69.351 386.285C69.5493 386.343 69.7404 386.424 69.9207 386.525C70.1197 386.639 70.3101 386.767 70.4904 386.908C70.6763 387.064 70.8519 387.232 71.0162 387.411C71.1881 387.606 71.3491 387.81 71.4983 388.023C71.6516 388.253 71.794 388.493 71.9365 388.756C72.0831 389.025 72.2148 389.302 72.3309 389.586C72.4514 389.882 72.5609 390.188 72.6705 390.505C72.78 390.822 72.8786 391.161 72.9663 391.522C73.0539 391.882 73.1415 392.243 73.2182 392.615C73.2949 392.987 73.3607 393.391 73.4154 393.796C73.4702 394.2 73.514 394.605 73.5578 395.031C73.6017 395.457 73.5578 395.906 73.6345 396.354C73.7112 396.802 73.6345 397.261 73.6345 397.742C73.6345 398.223 73.6345 398.661 73.6345 399.098C73.6345 399.535 73.5798 399.94 73.5469 400.333C73.514 400.727 73.4593 401.099 73.4045 401.427C73.3497 401.754 73.273 402.104 73.1963 402.421C73.1284 402.714 73.0443 403.002 72.9444 403.285C72.8649 403.536 72.766 403.781 72.6486 404.018C72.5479 404.227 72.4307 404.428 72.298 404.619C72.18 404.789 72.0441 404.947 71.8926 405.089C71.7582 405.212 71.6069 405.315 71.4435 405.395C71.286 405.466 71.1204 405.517 70.9505 405.548C70.7722 405.57 70.5919 405.57 70.4137 405.548C70.2153 405.512 70.0208 405.458 69.833 405.384L69.855 405.395ZM91.9518 414.425C91.8113 414.37 91.6787 414.297 91.5574 414.207C91.4229 414.106 91.2982 413.992 91.1849 413.868C91.0543 413.73 90.9369 413.58 90.8344 413.42C90.7153 413.24 90.6056 413.053 90.5057 412.862C90.4071 412.654 90.3085 412.436 90.2209 412.195C90.1201 411.948 90.0324 411.697 89.9579 411.441C89.8703 411.171 89.7936 410.887 89.7279 410.588C89.6512 410.293 89.5855 409.976 89.5197 409.648C89.454 409.32 89.4102 408.981 89.3663 408.631C89.3225 408.281 89.2787 407.921 89.2458 407.538C89.213 407.155 89.1911 406.794 89.1692 406.445C89.1472 406.095 89.1692 405.647 89.1692 405.242C89.1692 404.837 89.1692 404.422 89.1692 404.039C89.1692 403.657 89.1692 403.296 89.1692 402.946C89.1692 402.596 89.1692 402.279 89.2568 401.973C89.3444 401.667 89.3554 401.372 89.4102 401.109C89.4649 400.847 89.5197 400.585 89.5855 400.355C89.6467 400.143 89.7198 399.935 89.8046 399.732C89.8752 399.558 89.9595 399.39 90.0565 399.229C90.1407 399.094 90.24 398.97 90.3523 398.857C90.4448 398.758 90.5519 398.673 90.67 398.606C90.7753 398.548 90.8905 398.511 91.0096 398.497C91.1296 398.48 91.2512 398.48 91.3712 398.497C91.5098 398.532 91.6425 398.588 91.7656 398.661C91.8544 398.707 91.9387 398.762 92.0175 398.825C92.103 398.892 92.1835 398.965 92.2585 399.043C92.3406 399.126 92.4174 399.213 92.4886 399.306L92.7077 399.612L92.9159 399.962L93.1131 400.333C93.1678 400.464 93.2336 400.596 93.2883 400.738L93.4527 401.175C93.4527 401.317 93.5513 401.47 93.6061 401.623L93.7375 402.093C93.7375 402.257 93.8142 402.421 93.8471 402.585C93.8799 402.749 93.9238 402.913 93.9566 403.088C93.9895 403.263 93.9566 403.416 94.0333 403.591C94.066 403.757 94.0879 403.925 94.099 404.094C94.099 404.258 94.099 404.433 94.099 404.597V405.1L92.894 404.488L92.8282 403.941C92.8282 403.766 92.8282 403.591 92.7406 403.416C92.6529 403.241 92.6639 403.077 92.6201 402.913C92.5842 402.75 92.5366 402.589 92.4777 402.432C92.4362 402.285 92.3812 402.143 92.3133 402.006C92.2625 401.887 92.2002 401.774 92.1271 401.667C92.0666 401.573 91.9968 401.485 91.9189 401.405C91.8516 401.338 91.7739 401.283 91.6889 401.241C91.6314 401.207 91.5682 401.185 91.5026 401.175C91.4447 401.164 91.3853 401.164 91.3273 401.175C91.2652 401.185 91.2056 401.208 91.1521 401.241C91.0922 401.286 91.0371 401.337 90.9877 401.394C90.9329 401.462 90.8851 401.535 90.8453 401.612C90.7956 401.712 90.7517 401.814 90.7139 401.918C90.7139 402.039 90.6372 402.17 90.6043 402.312C90.5714 402.454 90.5386 402.629 90.5167 402.804C90.4947 402.979 90.5167 403.176 90.44 403.383C90.3633 403.591 90.44 403.821 90.44 404.072C90.44 404.324 90.44 404.586 90.44 404.87V405.767C90.44 406.117 90.44 406.434 90.44 406.751C90.44 407.068 90.44 407.352 90.44 407.625C90.44 407.899 90.44 408.161 90.5167 408.402C90.5933 408.642 90.5824 408.872 90.6152 409.09C90.6481 409.309 90.6919 409.484 90.7358 409.67C90.7796 409.856 90.8234 410.009 90.8672 410.162C90.911 410.315 90.9658 410.457 91.0206 410.588C91.1149 410.803 91.2247 411.012 91.3493 411.211L91.5245 411.43L91.6998 411.594C91.7571 411.635 91.8197 411.668 91.8861 411.692C91.9404 411.702 91.996 411.702 92.0504 411.692C92.1009 411.704 92.1533 411.704 92.2038 411.692C92.2506 411.703 92.2993 411.703 92.3462 411.692C92.3952 411.663 92.4395 411.626 92.4777 411.583L92.5872 411.43L92.6858 411.255C92.6858 411.189 92.6858 411.124 92.7734 411.047L92.8392 410.807C92.8454 410.723 92.8454 410.639 92.8392 410.555C92.8392 410.468 92.8392 410.38 92.8392 410.293V410.031C92.8392 409.943 92.8392 409.856 92.8392 409.768V408.85L91.9628 408.314V406.128L94.351 407.319L94.4277 415.256L93.6389 414.928V412.928C93.6389 413.004 93.6389 413.081 93.5622 413.157C93.5397 413.233 93.5104 413.306 93.4746 413.376C93.4502 413.454 93.4209 413.531 93.3869 413.605L93.3322 413.78C93.3004 413.849 93.2638 413.914 93.2226 413.977L93.0912 414.152L92.9597 414.294L92.8063 414.414C92.7557 414.446 92.7001 414.468 92.642 414.48H92.4448H92.2476L92.0175 414.404L91.9518 414.425ZM109.568 398.234L43.628 353.99C43.1702 353.658 42.616 353.485 42.0504 353.498C41.5515 353.538 41.0861 353.765 40.7467 354.132C40.2783 354.611 39.9325 355.196 39.7388 355.837C39.4771 356.662 39.3368 357.52 39.3225 358.385L37.8983 402.848C37.8706 403.892 37.955 404.937 38.1503 405.964C38.3331 406.913 38.6273 407.838 39.0267 408.719C39.3569 409.473 39.8042 410.17 40.3523 410.785C40.7954 411.286 41.3618 411.663 41.9956 411.878L110.543 432.104C110.636 432.129 110.735 432.125 110.825 432.092C110.915 432.058 110.993 431.997 111.047 431.918C111.235 431.683 111.369 431.411 111.441 431.12C111.566 430.707 111.647 430.281 111.682 429.851C111.722 429.309 111.722 428.765 111.682 428.222L110.937 403.176C110.92 402.623 110.869 402.072 110.784 401.525C110.71 401.027 110.608 400.535 110.477 400.049C110.36 399.674 110.214 399.308 110.039 398.956C109.916 398.697 109.736 398.469 109.513 398.289"
                                fill="var(--lobbyButton)"
                                stroke="var(--lobbyStroke)"
                            />
                            <path
                                id="Vector_82"
                                d="M101.888 409.724L101.373 409.462L101.998 413.507L101.538 416.907L102.053 417.126L102.754 413.846L101.888 409.713V409.724ZM103.137 410.337L102.633 410.085L103.247 414.065L102.798 417.432L103.301 417.64L103.981 414.415L103.192 410.348L103.137 410.337ZM61.0797 381.857L59.0859 380.764L58.801 400.661L64.9689 403.198V399.918L60.8387 398.125L61.0469 381.934L61.0797 381.857ZM80.9307 392.855L79.4737 392.046V402.695C79.4737 403.023 79.4737 403.318 79.4737 403.591C79.4651 403.836 79.4432 404.081 79.408 404.324C79.3793 404.524 79.3354 404.721 79.2765 404.914C79.2354 405.063 79.1765 405.206 79.1012 405.34C79.0427 405.449 78.9689 405.548 78.8821 405.636C78.8118 405.704 78.7302 405.759 78.6411 405.8C78.5511 405.821 78.4572 405.821 78.3672 405.8C78.2608 405.795 78.1565 405.769 78.0604 405.723C77.9465 405.676 77.8395 405.613 77.7427 405.537C77.6432 405.447 77.5516 405.348 77.4689 405.242C77.3737 405.122 77.2894 404.994 77.2169 404.859C77.1316 404.7 77.0548 404.535 76.9868 404.367C76.9211 404.182 76.8663 403.985 76.8115 403.766C76.7543 403.528 76.7104 403.287 76.6801 403.045C76.6801 402.793 76.6801 402.52 76.6034 402.225C76.5267 401.929 76.6034 401.623 76.6034 401.295V390.363L75.0149 389.488V400.333C75.0149 400.705 75.0149 401.066 75.0149 401.427C75.0149 401.787 75.0149 402.104 75.0806 402.443C75.1463 402.782 75.0806 403.088 75.1682 403.394C75.2559 403.701 75.2559 404.007 75.3107 404.291C75.3654 404.575 75.4202 404.859 75.486 405.122C75.5517 405.384 75.6284 405.647 75.7051 405.887C75.7817 406.128 75.8803 406.357 75.9789 406.576C76.0775 406.794 76.1871 406.991 76.2966 407.188C76.4082 407.372 76.5327 407.547 76.6691 407.713C76.7936 407.871 76.933 408.018 77.0854 408.15C77.235 408.28 77.3923 408.4 77.5565 408.511C77.725 408.611 77.9007 408.699 78.0824 408.773C78.2482 408.845 78.4207 408.899 78.5973 408.937H79.0574C79.3343 408.913 79.5976 408.806 79.8133 408.631C79.9199 408.525 80.0188 408.412 80.1091 408.292C80.2019 408.152 80.286 408.006 80.3611 407.855C80.4406 407.677 80.5101 407.494 80.5692 407.308C80.5692 407.111 80.6788 406.904 80.7226 406.674C80.7664 406.445 80.8102 406.193 80.8431 405.931C80.876 405.668 80.9088 405.395 80.9307 405.111C80.9526 404.827 80.9307 404.52 80.9307 404.203C80.9307 403.886 80.9307 403.558 80.9307 403.219V392.833V392.855ZM87.964 396.736L86.6932 396.026L86.759 406.641L83.6915 394.386L82.3768 393.632L82.4754 410.315L83.8558 410.883L83.7791 399.48L87.0657 412.184L88.2379 412.654L87.964 396.758V396.736ZM98.996 402.848L95.3917 400.847L95.6328 415.726L99.3137 417.246V414.753L96.7392 413.66L96.6187 409.954L98.8098 411.047V408.642L96.6187 407.549L96.5201 403.941L99.0399 405.275V402.859L98.996 402.848ZM69.9097 402.312C69.7489 402.242 69.6008 402.146 69.4715 402.028C69.3201 401.894 69.1842 401.744 69.0661 401.58C68.9358 401.38 68.8187 401.172 68.7156 400.956C68.606 400.716 68.5074 400.454 68.4088 400.169C68.3055 399.847 68.2249 399.519 68.1678 399.185C68.0886 398.791 68.0301 398.394 67.9925 397.994C67.9487 397.556 67.9158 397.086 67.8939 396.583C67.8939 396.091 67.8939 395.556 67.8939 394.976C67.8939 394.397 67.8939 393.883 67.8939 393.38C67.8939 392.877 67.9597 392.451 68.0144 392.057C68.053 391.69 68.1115 391.325 68.1897 390.964C68.2552 390.707 68.3395 390.455 68.4417 390.21C68.5258 390.029 68.6326 389.86 68.7594 389.707C68.8541 389.585 68.9735 389.484 69.11 389.412C69.2369 389.354 69.376 389.328 69.5153 389.335C69.6676 389.361 69.8153 389.408 69.9535 389.477C70.1116 389.569 70.2586 389.68 70.3917 389.805C70.5359 389.952 70.6644 390.113 70.7752 390.286C70.9038 390.497 71.0173 390.716 71.1148 390.942C71.2134 391.183 71.312 391.456 71.3996 391.751C71.494 392.071 71.5708 392.396 71.6297 392.724C71.6954 393.081 71.7502 393.475 71.794 393.905C71.794 394.342 71.8707 394.801 71.8926 395.293C71.9145 395.785 71.8926 396.321 71.8926 396.889C71.8926 397.458 71.8926 397.983 71.8926 398.42C71.8926 398.857 71.8378 399.306 71.794 399.688C71.7502 400.071 71.6845 400.399 71.6187 400.694C71.5547 400.947 71.4742 401.195 71.3777 401.437C71.2996 401.62 71.2003 401.792 71.0819 401.951C70.9856 402.071 70.871 402.174 70.7423 402.257C70.6204 402.321 70.4853 402.354 70.3479 402.356C70.1929 402.355 70.0398 402.322 69.8987 402.257L69.9097 402.312ZM69.9754 386.471C69.7951 386.37 69.604 386.289 69.4058 386.23C69.2332 386.17 69.0516 386.141 68.8689 386.143C68.694 386.135 68.5192 386.161 68.3541 386.219C68.1866 386.277 68.0281 386.358 67.883 386.46C67.7223 386.574 67.5785 386.71 67.4557 386.864C67.3044 387.031 67.1722 387.215 67.0613 387.411C66.9344 387.643 66.8246 387.884 66.7327 388.132C66.616 388.418 66.5172 388.71 66.4369 389.007C66.3492 389.328 66.2725 389.667 66.2068 390.024C66.1411 390.385 66.0863 390.767 66.0425 391.183C65.9987 391.598 65.9548 392.024 65.9329 392.473C65.911 392.921 65.9329 393.413 65.9329 393.916C65.9329 394.419 65.9329 394.911 65.9329 395.392C65.9329 395.873 65.9329 396.332 66.0096 396.791C66.0863 397.25 66.0973 397.677 66.163 398.103C66.2287 398.529 66.2945 398.945 66.3711 399.349C66.4478 399.754 66.5464 400.136 66.645 400.443C66.7436 400.749 66.8532 401.153 66.9737 401.536C67.0942 401.918 67.2147 402.17 67.3462 402.476C67.4776 402.782 67.62 403.045 67.7734 403.307C67.92 403.55 68.081 403.783 68.2555 404.007C68.4096 404.215 68.5819 404.408 68.7704 404.586C68.9398 404.748 69.123 404.894 69.3181 405.023C69.5056 405.146 69.7036 405.252 69.9097 405.34C70.0974 405.414 70.2919 405.469 70.4903 405.504C70.6686 405.526 70.8489 405.526 71.0271 405.504C71.1971 405.474 71.3626 405.422 71.5201 405.351C71.6836 405.271 71.8348 405.168 71.9693 405.045C72.1208 404.903 72.2566 404.746 72.3746 404.575C72.5073 404.384 72.6245 404.183 72.7252 403.974C72.8426 403.738 72.9415 403.493 73.021 403.241C73.1209 402.958 73.205 402.67 73.273 402.378C73.3497 402.061 73.4154 401.733 73.4811 401.383C73.5469 401.033 73.5797 400.661 73.6236 400.29C73.6674 399.918 73.6126 399.568 73.6126 399.109C73.6126 398.65 73.6126 398.223 73.6126 397.753C73.6126 397.283 73.6126 396.813 73.6126 396.365C73.6126 395.916 73.6126 395.468 73.5359 395.042C73.4592 394.615 73.4483 394.2 73.3935 393.806C73.3387 393.413 73.273 393.008 73.1963 392.626C73.1196 392.243 73.032 391.871 72.9443 391.532C72.8567 391.194 72.7581 390.844 72.6485 390.516C72.539 390.188 72.4294 389.893 72.3089 389.597C72.1929 389.313 72.0612 389.036 71.9145 388.767C71.7721 388.504 71.6297 388.264 71.4763 388.034C71.3271 387.821 71.1662 387.617 70.9943 387.422C70.83 387.243 70.6544 387.075 70.4684 386.919C70.2881 386.778 70.0977 386.65 69.8987 386.536L69.9754 386.471ZM91.8094 398.693C91.6863 398.62 91.5535 398.565 91.415 398.529C91.295 398.513 91.1734 398.513 91.0534 398.529C90.9343 398.544 90.8191 398.581 90.7138 398.639C90.5957 398.706 90.4886 398.791 90.3961 398.89C90.2838 399.002 90.1845 399.127 90.1003 399.262C90.0033 399.423 89.919 399.591 89.8484 399.765C89.7636 399.968 89.6905 400.176 89.6293 400.388C89.5635 400.617 89.5087 400.869 89.454 401.142C89.3992 401.416 89.3444 401.7 89.3006 402.006C89.2568 402.312 89.2349 402.629 89.2129 402.979C89.191 403.329 89.2129 403.679 89.2129 404.072C89.2129 404.466 89.2129 404.859 89.2129 405.275C89.2129 405.69 89.2129 406.084 89.2129 406.477C89.2129 406.871 89.2129 407.243 89.2896 407.571C89.3663 407.899 89.3663 408.303 89.4101 408.664C89.454 409.025 89.5087 409.353 89.5635 409.681C89.6183 410.009 89.695 410.326 89.7717 410.621C89.8484 410.916 89.9141 411.2 90.0017 411.474C90.0762 411.729 90.1639 411.981 90.2647 412.228C90.3523 412.468 90.4509 412.687 90.5495 412.895C90.6494 413.086 90.7591 413.272 90.8782 413.452C90.9807 413.612 91.0981 413.763 91.2287 413.901C91.342 414.025 91.4667 414.139 91.6012 414.24C91.7225 414.329 91.8551 414.403 91.9956 414.458L92.2257 414.535H92.4228H92.62C92.6782 414.523 92.7338 414.5 92.7844 414.469L92.9377 414.349L93.0692 414.207L93.2007 414.032C93.2519 413.952 93.2959 413.868 93.3321 413.78L93.4307 413.573C93.4647 413.498 93.494 413.421 93.5184 413.343C93.5542 413.273 93.5835 413.2 93.606 413.124C93.606 413.048 93.6608 412.971 93.6827 412.895V414.896L94.4715 415.224L94.34 407.319L91.9299 406.128V408.314L93.124 408.872V409.79C93.124 409.877 93.124 409.965 93.124 410.052V410.315C93.124 410.402 93.124 410.49 93.124 410.577C93.1302 410.661 93.1302 410.745 93.124 410.829L93.0583 411.069C93.0583 411.146 93.0583 411.211 92.9706 411.277L92.872 411.452L92.7625 411.605C92.7243 411.648 92.68 411.684 92.631 411.714C92.5841 411.725 92.5354 411.725 92.4886 411.714C92.4381 411.725 92.3857 411.725 92.3352 411.714C92.2808 411.724 92.2253 411.724 92.1709 411.714C92.1046 411.69 92.0419 411.657 91.9846 411.616L91.8094 411.452L91.6341 411.233C91.5095 411.034 91.3997 410.825 91.3054 410.61C91.2506 410.479 91.2068 410.348 91.152 410.184C91.0973 410.02 91.0644 409.867 91.0206 409.692C90.9767 409.517 90.9329 409.32 90.9001 409.112C90.8672 408.904 90.8343 408.675 90.8015 408.423C90.7686 408.172 90.8015 407.921 90.7248 407.647C90.6481 407.374 90.7248 407.079 90.7248 406.773C90.7248 406.466 90.7248 406.138 90.7248 405.789V404.892C90.7248 404.608 90.7248 404.346 90.7248 404.094C90.7248 403.843 90.7248 403.613 90.7248 403.405C90.7248 403.198 90.7248 403.001 90.8015 402.826C90.8782 402.651 90.8015 402.487 90.8891 402.334C90.9767 402.181 90.9658 402.061 90.9987 401.94C91.0365 401.836 91.0804 401.734 91.1301 401.634C91.1699 401.557 91.2177 401.483 91.2725 401.416C91.3219 401.359 91.377 401.308 91.4369 401.263C91.4904 401.229 91.55 401.207 91.6122 401.197C91.6701 401.186 91.7295 401.186 91.7874 401.197C91.8531 401.207 91.9162 401.229 91.9737 401.263C92.0588 401.304 92.1365 401.36 92.2037 401.427C92.2816 401.507 92.3514 401.595 92.4119 401.689C92.485 401.795 92.5474 401.909 92.5981 402.028C92.666 402.165 92.721 402.307 92.7625 402.454C92.8214 402.611 92.869 402.772 92.9049 402.935C92.9049 403.099 92.9925 403.263 93.0254 403.438C93.0583 403.613 93.0911 403.788 93.113 403.963L93.1788 404.51L94.3838 405.122V404.619C94.3838 404.455 94.3838 404.28 94.3838 404.116C94.3727 403.947 94.3508 403.779 94.3181 403.613C94.3181 403.438 94.3181 403.274 94.2414 403.11C94.1647 402.946 94.1757 402.771 94.1319 402.607C94.0881 402.443 94.0552 402.279 94.0223 402.115L93.8909 401.645C93.8909 401.492 93.7923 401.339 93.7375 401.197L93.5732 400.76C93.5184 400.617 93.4526 400.486 93.3979 400.355L93.2007 399.983L92.9925 399.634L92.7734 399.327C92.7022 399.235 92.6254 399.148 92.5434 399.065C92.4683 398.987 92.3878 398.913 92.3023 398.846C92.2235 398.784 92.1392 398.729 92.0504 398.682"
                                fill="white"
                            />
                            <path
                                id="Vector_83"
                                d="M41.9955 411.879C41.3617 411.663 40.7953 411.287 40.3523 410.786C39.8042 410.171 39.3568 409.473 39.0267 408.719C38.6272 407.839 38.3331 406.914 38.1502 405.964C37.955 404.938 37.8705 403.893 37.8983 402.849L39.3225 358.342C39.341 357.492 39.4811 356.649 39.7388 355.838C39.9325 355.197 40.2782 354.612 40.7466 354.133C41.0968 353.756 41.5798 353.528 42.0941 353.499C42.6598 353.486 43.214 353.659 43.6717 353.991L109.568 398.235C109.791 398.415 109.971 398.643 110.094 398.902C110.268 399.254 110.415 399.62 110.532 399.995C110.663 400.481 110.765 400.974 110.839 401.471C110.923 402.018 110.975 402.569 110.992 403.122L111.737 428.169C111.777 428.711 111.777 429.255 111.737 429.798C111.702 430.228 111.621 430.653 111.496 431.066C111.424 431.357 111.289 431.629 111.102 431.864C111.048 431.944 110.97 432.004 110.88 432.038C110.789 432.071 110.691 432.075 110.598 432.05L41.9955 411.879ZM109.546 397.382L43.6608 352.558C43.1136 352.151 42.4483 351.932 41.7655 351.935C41.1494 351.975 40.5708 352.244 40.1441 352.69C39.5981 353.272 39.1999 353.977 38.9828 354.745C38.6622 355.742 38.4887 356.781 38.4679 357.828L37.0109 402.542C36.9678 403.804 37.0707 405.066 37.3176 406.303C37.5477 407.437 37.9156 408.538 38.4132 409.583C38.8108 410.492 39.3548 411.331 40.0236 412.065C40.5491 412.671 41.2312 413.121 41.9955 413.366L110.609 432.946C110.722 432.974 110.841 432.967 110.951 432.926C111.06 432.885 111.155 432.812 111.222 432.717C111.444 432.432 111.604 432.104 111.693 431.754C111.829 431.253 111.925 430.741 111.978 430.224C112.04 429.577 112.062 428.927 112.044 428.278L111.288 403.308C111.27 402.645 111.211 401.984 111.113 401.329C111.025 400.735 110.9 400.147 110.74 399.569C110.605 399.092 110.429 398.627 110.214 398.18C110.057 397.866 109.828 397.593 109.546 397.382Z"
                                fill="white"
                            />
                        </g>
                    </g>
                </g>
            </g> -->
            <g id="help-page" class="with-link">
                <title>Go to Help Page</title>
                <g id="Vector_84">
                    <path
                        d="M1010.1 485.009C1009.45 483.751 1008.69 481.923 1008.52 480.044H1009.38C1010.22 480.044 1010.9 479.361 1010.9 478.522C1010.9 477.682 1010.22 477 1009.38 477H1005.61C1004.77 477 1004.09 477.682 1004.09 478.522C1004.09 479.361 1004.77 480.044 1005.61 480.044H1006.47C1006.3 481.923 1005.54 483.751 1004.89 485.009C995.406 486.283 988.092 494.406 988.092 504.238H1026.89C1026.9 494.406 1019.59 486.283 1010.1 485.009Z"
                        fill="var(--lobbyBell)"
                        stroke="var(--lobbyBellStroke)"
                    />
                    <path
                        d="M1031.02 509.884C1030.65 506.873 1026.88 506.497 1026.88 506.497H988.114C988.114 506.497 984.348 506.873 983.975 509.884H982V513.086C994.31 512.825 1005.67 512.536 1015.93 512.221C1022.74 511.885 1028.47 511.532 1033 511.164V509.884H1031.02Z"
                        fill="var(--lobbyBell)"
                        stroke="var(--lobbyBellStroke)"
                    />
                </g>
                <path
                    id="Subtract_2"
                    opacity="0.5"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M999.936 512.671C1005.57 512.527 1010.94 512.377 1016.04 512.221C1022.85 511.884 1028.58 511.531 1033.12 511.164V509.884H1031.14C1030.76 506.872 1027 506.497 1027 506.497H1007.7C1005.81 508.898 1003.28 511.012 999.936 512.671ZM1009.24 504.237C1012.62 498.53 1013.07 491.646 1012.45 485.444C1020.83 487.595 1027.01 495.193 1027.01 504.237H1009.24Z"
                    fill="var(--lobbyBellShadow)"
                />
            </g>
            <!-- TODO: After fact bootcamp Buttons Will be added as HTML element  -->

            <g id="Guestbook" class="with-link hidden">
                <rect
                    x="972.5"
                    y="628.5"
                    width="409"
                    height="41"
                    rx="5.5"
                    fill="var(--lobbyButton)"
                    stroke="var(--lobbyButtonBorder)"
                />
                <text
                    id="LOGOUT_2"
                    fill="white"
                    xml:space="preserve"
                    style="white-space: pre"
                    font-family="Public Sans"
                    font-size="16"
                    font-weight="bold"
                    letter-spacing="0px"
                >
                    <tspan x="993.227" y="654.8">
                        SIGN OUR 25TH ANNIVERSARY GUESTBOOK &#xbb;
                    </tspan>
                </text>
            </g>
        </g>
        <defs>
            <filter
                id="filter0_f"
                x="463"
                y="504"
                width="733"
                height="246"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                />
                <feGaussianBlur
                    stdDeviation="5"
                    result="effect1_foregroundBlur"
                />
            </filter>
            <filter
                id="filter1_f"
                x="160"
                y="663"
                width="439"
                height="233.611"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                />
                <feGaussianBlur
                    stdDeviation="2"
                    result="effect1_foregroundBlur"
                />
            </filter>
            <filter
                id="filter2_d"
                x="312"
                y="35"
                width="234"
                height="221.264"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow"
                    result="shape"
                />
            </filter>
            <filter
                id="filter3_d"
                x="12"
                y="0"
                width="129.502"
                height="340"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow"
                    result="shape"
                />
            </filter>
            <filter
                id="filter4_d"
                x="965.504"
                y="592"
                width="427.983"
                height="210.182"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dx="4" dy="4" />
                <feGaussianBlur stdDeviation="10" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow"
                    result="shape"
                />
            </filter>
            <filter
                id="filter5_d"
                x="423.651"
                y="586"
                width="559.697"
                height="267.956"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dx="4" dy="4" />
                <feGaussianBlur stdDeviation="10" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow"
                    result="shape"
                />
            </filter>
            <filter
                id="filter6_d"
                x="132"
                y="171"
                width="282.179"
                height="781.772"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dx="4" dy="4" />
                <feGaussianBlur stdDeviation="5" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow"
                    result="shape"
                />
            </filter>
            <filter
                id="filter7_d"
                x="262.161"
                y="673.772"
                width="15"
                height="265"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="-4" />
                <feGaussianBlur stdDeviation="2" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow"
                    result="shape"
                />
            </filter>
            <filter
                id="filter8_d"
                x="136"
                y="177"
                width="268.179"
                height="17.2278"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow"
                    result="shape"
                />
            </filter>
            <filter
                id="filter9_d"
                x="134"
                y="803"
                width="268.179"
                height="17.2278"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="-4" />
                <feGaussianBlur stdDeviation="2" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow"
                    result="shape"
                />
            </filter>
            <filter
                id="filter10_d"
                x="1258.49"
                y="35"
                width="189.785"
                height="159"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow"
                    result="shape"
                />
            </filter>
            <linearGradient
                id="paint0_linear"
                x1="721"
                y1="640"
                x2="720.599"
                y2="938.999"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="white" />
                <stop offset="1" stop-color="#8098AD" />
            </linearGradient>
            <linearGradient
                id="paint1_linear"
                x1="720"
                y1="34"
                x2="720"
                y2="129"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#8098AD" />
                <stop offset="1" stop-color="white" />
            </linearGradient>
            <linearGradient
                id="paint2_linear"
                x1="96"
                y1="322"
                x2="190"
                y2="360"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#012853" />
                <stop offset="1" />
            </linearGradient>
            <linearGradient
                id="paint3_linear"
                x1="-1.89664e-06"
                y1="410"
                x2="186"
                y2="422"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#2D5F94" />
                <stop offset="1" stop-color="#042B55" />
            </linearGradient>
            <linearGradient
                id="paint4_linear"
                x1="504"
                y1="615"
                x2="1155"
                y2="614"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#002651" />
                <stop offset="0.519414" stop-color="#083464" />
                <stop offset="1" stop-color="#002751" />
            </linearGradient>
            <linearGradient
                id="paint5_linear"
                x1="1360"
                y1="421.128"
                x2="1445.44"
                y2="421.128"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#8098AD" />
                <stop offset="1" stop-color="#8098AD" />
            </linearGradient>
            <linearGradient
                id="paint6_linear"
                x1="1178.87"
                y1="777.813"
                x2="1178.87"
                y2="878"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#C4C4C4" />
                <stop offset="1" stop-color="#C4C4C4" stop-opacity="0" />
            </linearGradient>
            <linearGradient
                id="paint7_linear"
                x1="706"
                y1="832"
                x2="706"
                y2="935"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#C4C4C4" />
                <stop offset="1" stop-color="#C4C4C4" stop-opacity="0" />
            </linearGradient>
            <linearGradient
                id="paint8_linear"
                x1="401.661"
                y1="681.772"
                x2="401.661"
                y2="688.772"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#1B1247" />
                <stop offset="1" />
            </linearGradient>
        </defs>
    </svg>
</template>

<script>
export default {
    name: "HomeLobby"
};
</script>
